
import React, { useState, useEffect, Fragment } from 'react';

const Logout = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (localStorage.getItem('token') == null) {
            window.location.replace('/app/');
        } else {
            setLoading(false);
        }
    }, []);

  
    const handleLogout = e => {
        e.preventDefault();
    
        fetch('/api/users/auth/logout/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Token ${localStorage.getItem('token')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                localStorage.clear();
                window.location.replace('/app/');
            });
    };

    return (
        <div className="card card-body mt-4 mb-4">
            {loading === false && (
                <Fragment>
                    <h6>Are you sure you want to logout?</h6>
                    <button type='submit' value='Logout'
                            className="btn btn-primary rm-sm-2"
                        onClick={handleLogout}>
                        Logout
                    </button>
                    
                </Fragment>
            )}
        </div>
    );
};

export default Logout;